<app-modal-card>
  <p class="text-[19px] font-semibold fg-noir-1 text-center">
    {{ 'modal.reauth.title' | translate }}
  </p>

  <p class="text-[14px] fg-gris-1 text-center mt-[12px] whitespace-pre-line">
    {{ 'modal.reauth.subtitle' | translate }}
  </p>

  <div class="w-[400px] mt-[28px]">
    <app-auth-credentials-form #authForm (success)="success.emit($event)" />
  </div>

  <div class="flex gap-[10px] w-[400px] mt-auto">
    <button
      type="button"
      class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors"
      (click)="cancelClick.emit()"
    >
      {{ 'common.cancel' | translate }}
      <app-svg svgPath="assets/svg/close-circle.svg" width="20" height="20" />
    </button>
    <button
      type="button"
      class="h-[58px] w-full px-[20px] flex items-center justify-center bg-vert-1 rounded-[5px] text-[16px] font-semibold fg-blanc cursor-pointer disabled:opacity-50"
      [disabled]="authForm.working()"
      (click)="authForm.submit()"
    >
      {{ 'common.confirm' | translate }}
    </button>
  </div>
</app-modal-card>
